import Navigation from "./Navigation";
import './Heading.css';
import Testimonials from "../Testimonials/Testimonials";

export default function Heading() {
    return (
        <header>
            <Navigation />
            <div className="view wow fadeIn background">
                <div className="align-items-center vh-100">
                    <div className="container h-100 d-flex flex-column justify-content-evenly" style={{ paddingTop: '66px' }}>
                        <div>
                            <div className="text-center wow fadeInUp centerTitle">
                                <h1 className="main-title remove-margin text-uppercase wow fadeInDown" data-wow-delay="0.3s"><strong>Gradu8 Maths</strong></h1>
                                <hr className="hr-light my-4 wow fadeInDown" data-wow-delay="0.4s" />
                                <h5 className="sub-title text-uppercase mb-4 white-text wow fadeInDown" data-wow-delay="0.4s"><strong>Professional Mathematics Tuition</strong></h5>
                            </div>
                        </div>
                        <Testimonials />
                    </div>
                </div>
            </div>
        </header>
    );
};
